// Validación de contraseñas nuevas (§3): la regla compartida con manage-users y la repetición coincidente.
import { passwordProblem, type PasswordContext } from '../../supabase/functions/_shared/password-policy.ts';

export {
  PASSWORD_HINT,
  PASSWORD_MAX_BYTES,
  PASSWORD_MIN_LENGTH,
  type PasswordContext,
} from '../../supabase/functions/_shared/password-policy.ts';

export interface PasswordErrors {
  password?: string;
  repeat?: string;
}

export function validateNewPassword(password: string, repeat: string, context: PasswordContext = {}): PasswordErrors {
  const errors: PasswordErrors = {};
  const problem = passwordProblem(password, context);
  if (problem) errors.password = problem;
  if (repeat === '') {
    errors.repeat = 'Repite la contraseña.';
  } else if (repeat !== password) {
    errors.repeat = 'Las contraseñas no coinciden.';
  }
  return errors;
}

export function hasErrors(errors: object): boolean {
  return Object.values(errors).some(Boolean);
}
